/* eslint-disable prefer-const */
import { css, polished } from 'jimu-core';
import { hoverFocus, getBoxStyles } from 'jimu-theme';
export function buttonSize(sizeVars) {
    return sizeVars && css `
    padding: ${sizeVars.paddingY} ${sizeVars.paddingX};
    font-size: ${sizeVars.fontSize};
    line-height: ${sizeVars.lineHeight};
    border-radius: ${sizeVars.borderRadius};
    > .icon-btn-sizer {
      min-width: ${sizeVars.lineHeight};
      min-height: ${sizeVars.lineHeight};
      display: flex;
      justify-content: center;
      align-items: center;
      margin: auto;
    }
  `;
}
export function buttonVariantStyles(buttonVars) {
    const { default: defaultVars, hover: hoverVars, active: activeVars, focus: focusVars, disabled: disabledVars } = buttonVars;
    return buttonVars && defaultVars && css `
    ${getBoxStyles(defaultVars)};
    ${hoverVars && css `
      &:hover,
      &[aria-expanded="true"] {
        ${getBoxStyles(hoverVars)};
      }
    `}
    ${focusVars && css `
      &,
      &:not(:disabled):not(.disabled).active{
        &:focus,
        &.focus {
          /* ${getBoxStyles(focusVars)}
          outline: none; */
        }
      }
    `}
    ${activeVars && css `
      &:not(:disabled):not(.disabled).active {
      /* &[aria-expanded="true"] { */
        ${getBoxStyles(activeVars)}
      }
      &:not(:disabled):not(.disabled) {
        cursor: pointer;
      }
    `}

    ${disabledVars && css `
      &.disabled,
      &:disabled {
        &,
        &:hover {
          ${getBoxStyles(disabledVars)}
        }
      }`}
  `;
}
export function getIconButtonPadding(buttonSizeVars) {
    if (!buttonSizeVars)
        return;
    const { fontSize, lineHeight, paddingY } = buttonSizeVars;
    // Assuming the units are the same for font size and padding:
    // TODO: add more check for different units?
    let unitlessFontSize;
    let unit;
    let extraPadding = 0;
    let lineHeightUnit = 0;
    [unitlessFontSize, unit] = polished.getValueAndUnit(fontSize);
    const [unitlessPaddingY, paddingYUnit] = polished.getValueAndUnit(paddingY);
    lineHeightUnit = polished.getValueAndUnit(lineHeight)[1];
    // we force line height to be 1 for icon buttons,
    // thus need to add more space if the original line height is larger than 1
    if ((unitlessFontSize - 1) > 0) {
        extraPadding = (unitlessFontSize - 1) * 0.5;
    }
    // if line height has unit
    if (lineHeightUnit && paddingYUnit) {
        return `${(unitlessPaddingY)}${paddingYUnit}`;
    }
    return `${(extraPadding + unitlessFontSize * (lineHeight - 1) * 0.5 + unitlessPaddingY)}${unit}`;
}
export const buttonStyles = (props) => {
    const tagName = props.tag;
    return tagName === 'a'
        ? css `a& {
    ${_baseButtonStyles(props)}
  }`
        : _baseButtonStyles(props);
};
function _baseButtonStyles(props) {
    var _a, _b, _c, _d, _e, _f;
    if (!(props && props.theme && props.theme.components))
        return;
    const theme = props.theme;
    const buttonVars = (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.components) === null || _a === void 0 ? void 0 : _a.button) !== null && _b !== void 0 ? _b : {};
    const { sizes: buttonSizes, variants: buttonVariants, icon: buttonIcon } = buttonVars;
    const type = (_c = props.type) !== null && _c !== void 0 ? _c : 'default';
    const size = (_d = props.size) !== null && _d !== void 0 ? _d : 'default';
    const isIcon = props.icon;
    const isVertial = props.vertical;
    const buttonSizeVars = (_e = buttonSizes === null || buttonSizes === void 0 ? void 0 : buttonSizes[size]) !== null && _e !== void 0 ? _e : {};
    const buttonVariantVars = (_f = buttonVariants === null || buttonVariants === void 0 ? void 0 : buttonVariants[type]) !== null && _f !== void 0 ? _f : {};
    return css `
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    user-select: none;
    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out; /* $btn-transition */

    ${hoverFocus('text-decoration: none;')}

    /* Sizing: */
    ${buttonSize(buttonSizeVars)}

    /* Variant: */
    ${buttonVariantStyles(buttonVariantVars)}

    /* Icons in button: */
    .jimu-icon {
      pointer-events: none;
      flex-shrink: 0;
    }
    .jimu-icon,
    .left-icon {
      margin-right: ${buttonIcon ? buttonIcon.spacing : '.5rem'};
    }
    .right-icon {
      &,
      &.jimu-icon {
        margin-left: ${buttonIcon ? buttonIcon.spacing : '.5rem'};
        margin-right: auto;
      }
    }

    /* Icon button */
    ${isIcon && css `
      &.icon-btn {
        line-height: 1;
        .jimu-icon {
          display: block;
          margin-left: auto;
          margin-right: auto;
        }
        padding: ${getIconButtonPadding(buttonSizeVars)}
      }
      &.dropdown-button {
        .jimu-icon {
          margin-right: auto;
        }
      }
    `}

    /* Vertical Button */
    ${isVertial && !isIcon && css `
      .jimu-icon {
        &,
        &.right-icon {
          display: block;
          margin: 0 auto;
          margin-top: ${buttonIcon ? buttonIcon.spacing : '.5rem'};
          margin-bottom: ${buttonIcon ? buttonIcon.spacing : '.5rem'};
        }
      }
    `}

    /* handle truncated text */
    &.text-truncate .jimu-btn-text {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &.btn-block {
      display: block;
      width: 100%;
    }
  `;
}
